import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    nombre: '',
    inactivo: false,
    rowVersion: null,
    
    cancelacionMotivoDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_CANCELACION_MOTIVO'(state, cancelacionMotivoId) {
        state.id = cancelacionMotivoId;
        state.nombre = '';
        state.inactivo = false;
        state.rowVersion = null;
    },
    'SET_CANCELACION_MOTIVO'(state, cancelacionMotivo) {
        state.nombre = cancelacionMotivo.nombre.toUpperCase().trim();
        state.inactivo = cancelacionMotivo.inactivo;
        state.rowVersion = cancelacionMotivo.rowVersion;
    },

    'INICIALIZAR_DATOS'(state) {
        state.cancelacionMotivoDatos = [];
    },
    'SET_DATOS'(state, datos) {
        state.cancelacionMotivoDatos = datos;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, bancoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CANCELACION_MOTIVO', bancoId);

            if (bancoId != 0) {
                apiAxios.get('cancelacionesmotivos/' + bancoId + '/abm' ) 
                .then(res => {
                    commit('SET_CANCELACION_MOTIVO', res.data);
                    resolve();
                })
                .catch(error => reject(error))
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })
    },    
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let cancelacionMotivo = {
                nombre: state.nombre.toUpperCase().trim(),
                inactivo: state.inactivo,
            }

            let url = 'cancelacionesmotivos';
            if (state.id != 0) {
                url += '/' + state.id;
                cancelacionMotivo.rowVersion = state.rowVersion;
            }
            
            apiAxios.post(url, cancelacionMotivo)
                .then(() => {
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    getDatos ( { commit }, cancelacionMotivoId ) {
        return new Promise((resolve, reject) => {

            commit('INICIALIZAR_DATOS');
            
            let getDatos = false;
            if (cancelacionMotivoId) {
                if (cancelacionMotivoId != 0) {
                    getDatos = true;
                }
            }

            if (getDatos) {
                apiAxios.get('cancelacionesmotivos/' + cancelacionMotivoId ) 
                .then(res => {
                    var datos = [
                        { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                        { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                        { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': (res.data.inactivo) ? 'Si' : 'No', 'formato': '' },
                    ];
                    commit('SET_DATOS', datos);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })            
    },
    
    inactivar ( { }, cancelacionMotivoId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('cancelacionesmotivos/' + cancelacionMotivoId + '/inactivar')
                .then(() => {
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}